import React from 'react'
import styled from 'styled-components'

import AromiDishSelector from './AromiDishSelector'
import InputWithTags from './InputWithTags'
import PerformTaskForm from './PerformTaskForm'
import PerformTaskTitle from './PerformTaskTitle'
import {EventStatusCode, PerformableTask} from '../../../state/performTask/state'
import {useTranslation} from 'react-i18next'

interface PerformCoolerCoolingTaskProps {
  task: PerformableTask
  setValue: any
  onAssetSaved: () => void
  onAssetRemoved: (assetId: string) => void
  payload: any
  handleUpdate: () => void
  handleRemove: () => void
  hasCurrentEvent?: boolean
  currentEventId?: string
}

const PerformCoolerCoolingTask = ({
  task,
  setValue,
  onAssetSaved,
  onAssetRemoved,
  payload,
  handleRemove,
  hasCurrentEvent,
  currentEventId
}: PerformCoolerCoolingTaskProps) => {
  const {t} = useTranslation('tasks')
  return (
    <FormContainer>
      <PerformTaskTitle task={task} />
      <InputWithTags
        defaultSuggestions={task.defaultSuggestions || []}
        onChange={setValue}
        savedSuggestions={payload.suggestions}
        maxCharacters={100}
      />
      <AromiDishSelector task={task} payload={payload} setValue={setValue} />
      <PerformTaskForm
        onAssetSaved={onAssetSaved}
        onAssetRemoved={onAssetRemoved}
        onInputChange={setValue}
        payload={payload}
        handleRemove={handleRemove}
        setValue={setValue}
        confirm={t(
          'tasks:labels.confirmRemoveTask',
          'Are you sure you want to delete this task? This will also remove any associated resolved alarms.'
        )}
        hasCurrentEvent={!!hasCurrentEvent}
        currentEventId={currentEventId}
      />
    </FormContainer>
  )
}

export const FormContainer = styled.form`
  display: grid;
  grid-auto-flow: row;
  gap: 1rem;
`

export default PerformCoolerCoolingTask
